export const CARCASS_WEIGHT = 330;
export const LIVE_WEIGHT = 700;
export const BASE_FARM_GATE_PRICE = 4.32;
